import { Component, Input, OnChanges, OnDestroy, ChangeDetectionStrategy, ViewEncapsulation, SimpleChanges, ElementRef, ViewChild, Renderer2, HostListener, OnInit, Output, EventEmitter, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewportService } from 'src/app/services/viewport.service';
import { SwiperModule, SwiperComponent } from 'swiper/angular';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag'; import { Subscription } from 'rxjs';
import { SidebarModule } from 'primeng/sidebar'; import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Item } from 'src/app/models/liveshop'; import { InputNumberModule } from 'primeng/inputnumber';
import { HttpClientModule } from '@angular/common/http';
import { VideoItem } from 'src/app/models/video-item.model';
import { VideoModalService } from 'src/app/services/video-modal.service';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { LOCALE_ID } from '@angular/core'; import { environment } from 'src/environments/environment';
import { registerLocaleData } from '@angular/common';
import ptBr from '@angular/common/locales/pt';
registerLocaleData(ptBr);
const widgetEncapsulation = environment.isWidgetBuild ? ViewEncapsulation.ShadowDom : ViewEncapsulation.Emulated;
@Component({
  selector: 'app-carousel',
  standalone: true,
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule, HttpClientModule, SwiperModule, InputNumberModule, FormsModule, ReactiveFormsModule, SidebarModule, TagModule, ButtonModule],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' }
  ],
  encapsulation: ViewEncapsulation.Emulated,
})
export class CarouselComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() arraySlicksFull: Item[] = [];
  @Input() videoUrls: VideoItem[] = [];
  @Input() isAdmin: boolean = true;
  @Input() position: 'center' | 'top' | 'bottom' | 'left' | 'right' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright' = 'bottomright';
  @Input() showProducts?: boolean = false;
  @Input() showDescription?: boolean = false;
  @Input() backgroundColor?: string;
  @Input() isCol4: boolean = false;
  @Input() font_color: string = "#000000";
  @Input() highlight?: string;
  @Input() posterUrls: string[] = [];
  @Input() height: number | undefined;
  @Input() templateType: string | undefined;
  @Input() loadingComplete!: EventEmitter<void>;
  @Input() containerDiv?: ElementRef<HTMLDivElement>;
  @Input() pageToVideos: number = 0;
  @Input() widget_id?: number | undefined;
  @Input() totalAssets: number = 0;
  @Input() store_id?: number | undefined;
  @Input() template_id?: number | undefined;
  @Input() aspectRatio?: any;
  @Input() instanceId?: string;
  @Output() loadMoreVideos = new EventEmitter<void>();
  @Output() openSidebar = new EventEmitter<void>();
  @ViewChild(SwiperComponent) swiperComponent!: SwiperComponent;
  @Output() modalOpened = new EventEmitter<VideoItem>();

  slidesPerView: number = 1;
  containerClass: string = 'col-12';

  swiperKey: number = 0;  // Chave para forçar a recriação do Swiper

  // Controla a visibilidade das setas de navegação: o próprio Swiper (watchOverflow,
  // ligado no template) sabe se os slides cabem todos na área visível ou não —
  // "lock"/"unlock" disparam quando esse estado muda (inclusive em resize).
  isSwiperLocked = false;
  onSwiperLock(): void {
    this.isSwiperLocked = true;
    this.cdr.markForCheck();
  }
  onSwiperUnlock(): void {
    this.isSwiperLocked = false;
    this.cdr.markForCheck();
  }

  constructor(
    private cdr: ChangeDetectorRef,
    private viewportService: ViewportService,
    private host: ElementRef,
    private renderer: Renderer2,
    private videoModalService: VideoModalService
  ) { }
  private loadingCompleteSubscription?: Subscription;
  private resizeObserver?: ResizeObserver;

  ngOnInit(): void {
    console.log('[Carousel] ngOnInit templateType:', this.templateType, 'videos:', this.videoUrls?.length);

    this.updateSlidesPerView(window.innerWidth);

    // Assinando o evento `loadingComplete` para remover o item temporário assim que o carregamento é concluído
    if (this.loadingComplete) {
      this.loadingCompleteSubscription = this.loadingComplete.subscribe(() => {
        this.removeLoadingIndicator();
      });
    }

    if (this.containerDiv) {
      this.updateSlidesPerView(this.containerDiv.nativeElement.offsetWidth);
    }
  }
  itemClass = 'col-12-item';
  itemWidth: string = '200px';
  ngAfterViewInit(): void {
    if (this.containerDiv && this.containerDiv.nativeElement) {
      this.resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          const newWidth = entry.contentRect.width;

          this.itemWidth = newWidth < 1024 ? `${newWidth}px` : '200px';
          this.updateSlidesPerView(newWidth); // Certifique-se de que este método é chamado aqui
          this.cdr.detectChanges();
        }
      });
      this.resizeObserver.observe(this.containerDiv.nativeElement);
    }

    this.viewportService.setTemplateType(this.templateType);
  }

  openModal(video: VideoItem) {
    console.log('[Carousel] openModal', {
      templateType: this.templateType,
      videoUid: video?.uid,
      videos: this.videoUrls?.length
    });
    void this.videoModalService.open({
      video,
      slicks: this.arraySlicksFull,
      totalAssets: this.totalAssets,
      isAdmin: this.isAdmin,
      widgetId: this.widget_id,
      storeId: this.store_id,
      templateId: this.template_id,
      height: this.height,
      pageToVideos: this.pageToVideos,
      instanceId: this.instanceId
    });
    this.cdr.detectChanges();
    this.modalOpened.emit(video);
  }

  // trackByFn(index: number, item: string): any {
  //   return index; // ou item se os valores forem únicos
  // }
  trackByFn(index: number, item: VideoItem): any {
    return item.uid; // Podemos usar `item.uid` ou qualquer propriedade única para identificar o item
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['templateType'] || changes['videoUrls']) {
      console.log('[Carousel] ngOnChanges', { templateType: this.templateType, videos: this.videoUrls?.length, changeKeys: Object.keys(changes) });
    }
    if (changes['aspectRatio']) {
    }
    if (changes['store_id']) {
    }
    if (changes['template_id']) {
    }
    if (changes['totalAssets']) {
    }
    if (changes['widget_id']) {
    }
    if (changes['videoUrls']) {
      this.normalizeProductPrices();
      // Verifica se o `videoUrls` foi atualizado com novos vídeos
      this.removeLoadingIndicator(); // Remove o spinner de carregamento se houver vídeos novos
    }
    if (changes['loadingComplete'] && this.loadingComplete) {
      // Assina o evento `loadingComplete` para remover o indicador de carregamento
      this.removeLoadingIndicator();
    }
    if (changes['pageToVideos']) {
    }
  }
  normalizeProductPrices() {
    this.videoUrls = this.videoUrls.map(video => {
      if (video.products && Array.isArray(video.products)) {
        const updatedProducts = video.products.map(product => {
          const normalizedPrice =
            typeof product.price === 'string'
              ? parseFloat(product.price.replace(',', '.'))
              : product.price;

          return {
            ...product,
            price: normalizedPrice
          };
        });

        return {
          ...video,
          products: updatedProducts
        };
      }

      return video;
    });
  }

  // Função para emitir o evento quando o botão for clicado
  onOpenSidebar(): void {
    this.openSidebar.emit();
  }
  spaceBetween: number = 20;
  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    if (this.containerDiv && this.containerDiv.nativeElement) {
      const newWidth = this.containerDiv.nativeElement.offsetWidth; // Usa a largura do containerDiv
      this.updateSlidesPerView(newWidth); // Passa a largura do containerDiv
    }
  }
  updateSlidesPerView(containerWidth: number): void {
    this.spaceBetween = 10;
    this.cdr.detectChanges(); // Atualiza o layout

    // Aguarda o Swiper atualizar o layout antes de definir a largura do slide
    const swiperRef = this.swiperComponent?.swiperRef;

    // Verifique se o swiperRef e slides existem e possuem elementos
    if (swiperRef?.slides && swiperRef.slides.length > 0) {
      const firstSlide = swiperRef.slides[0] as HTMLElement;
      const slideWidth = firstSlide.offsetWidth;

      // Define a largura do slide na variável CSS
      const swiperElement = swiperRef.el;
      if (swiperElement) {
        // eslint-disable-next-line
        //swiperElement.style.setProperty('--slide-width', `${slideWidth}px`);
      }
    }
    this.cdr.detectChanges();
  }

  // Método para verificar se estamos no penúltimo slide e carregar mais vídeos
  onSwiperActiveIndexChange(): void {
    const slides = document.querySelectorAll('.swiper-slide');
    const activeIndex = this.swiperComponent?.swiperRef?.activeIndex ?? -1;

    // Calcule o número atual de slides visíveis
    const swiperWidth = this.swiperComponent?.swiperRef?.width ?? 1; // largura da área de visualização do Swiper
    const slideWidth = slides[0]?.clientWidth ?? swiperWidth; // largura de um slide (ou largura da área se não houver slides)
    const currentSlidesPerView = Math.floor(swiperWidth / slideWidth); // número estimado de slides visíveis

    // Ajustar o cálculo para disparar o evento de carregar mais vídeos, considerando slides visíveis atuais
    if (activeIndex >= slides.length - currentSlidesPerView - 1 && this.totalAssets > slides.length) {
      this.addLoadingIndicator();
      this.loadMoreVideos.emit();
    }
  }

  isLoading: boolean = false;
  // Método para adicionar o item temporário com o spinner
  addLoadingIndicator(): void {
    if (!this.isLoading) {
      this.isLoading = true;
      this.videoUrls = [...this.videoUrls, { uid: 'loading', id: -1, src: '', poster: '', isLoading: true, products: [] }];
      this.cdr.detectChanges();
    }
  }
  // Método para remover o item temporário com o spinner
  removeLoadingIndicator(): void {
    this.isLoading = false;
    this.videoUrls = this.videoUrls.filter(video => !video.isLoading);
    this.cdr.detectChanges();
  }
  addNewVideos(newVideos: VideoItem[]): void {
    if (newVideos.length > 0) {
      // Adiciona os novos vídeos ao array atual
      this.videoUrls = [...this.videoUrls, ...newVideos];

      // Forçar a detecção de mudanças para que o Swiper reconheça o novo conteúdo
      this.cdr.detectChanges();

      // Atualizar a chave do swiper para forçar a recriação do componente (se necessário)
      this.swiperKey++;
    }
  }
  isDragging = false;
  // Método que dispara ao iniciar o toque
  startX = 0;
  startY = 0;
  dragThreshold = 10; // Pixels mínimos para considerar um arraste

  // Método chamado no início do toque ou clique
  onTouchStart(event: MouseEvent | TouchEvent) {
    this.isDragging = false;
    this.startX = this.getEventX(event);
    this.startY = this.getEventY(event);
  }

  // Método chamado durante o movimento
  onTouchMove(event: MouseEvent | TouchEvent) {
    const currentX = this.getEventX(event);
    const currentY = this.getEventY(event);

    // Verifica se o movimento foi maior que o limiar
    if (Math.abs(currentX - this.startX) > this.dragThreshold || Math.abs(currentY - this.startY) > this.dragThreshold) {
      this.isDragging = true;
    }
  }

  onTouchEnd(event: MouseEvent | TouchEvent, video: VideoItem) {
    if (!this.isDragging) {
      this.openModal(video);
    }
    this.isDragging = false; // Reseta o estado
  }

  private getEventX(event: MouseEvent | TouchEvent): number {
    return event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
  }

  private getEventY(event: MouseEvent | TouchEvent): number {
    return event instanceof MouseEvent ? event.clientY : event.touches[0].clientY;
  }
  ngOnDestroy(): void {
    this.loadingCompleteSubscription?.unsubscribe();
    this.resizeObserver?.disconnect();
  }
  show: boolean = false;

  @ViewChild('swiper', { static: false }) swiperCarouselRef?: SwiperComponent;

  get swiperInstanceCarousel() {
    return this.swiperCarouselRef?.swiperRef;
  }

  hasDiscount(p: any): boolean {
    if (!p) return false;

    const price = Number(
      typeof p.price === 'string' ? p.price.replace(',', '.').trim() : p.price
    );
    const compare = Number(
      typeof p.compare_at_price === 'string'
        ? p.compare_at_price.replace(',', '.').trim()
        : p.compare_at_price
    );

    return !!compare && compare > price;
  }

}




